<template>

<div class="input multiselect" :data-theme="theme" v-click-outside="onOutsideClick">

    <core-input-textbox :placeholder="placeholder" v-model="model.search" v-on:focus="isExpanded = true" v-on:blur="isExpanded = false" />

    <div class="multiselect-options" v-if="isSearching">

        <div class="multiselect-option" v-for="option in finalOptions" :key="option.value" v-on:click="onOptionClick(option.value)">
        
            {{ option.text }}

        </div>

    </div>

    <div class="multiselect-selections" v-if="selected.length">

        <div class="multiselect-selection" v-tooltip="'Click to remove'" v-for="option in selected" :key="option.value"  v-on:click="onSelectionClick(option.value)">

            <div class="multiselect-selection-name">{{ option.text }}</div>

            <div class="multiselect-selection-icon">
                <i class="fa-sharp fa-remove" />
            </div>

        </div>

    </div>

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'options', 'theme', 'value', 'placeholder'
	],

    data: function() {

        return {
            model: {
                search: ''
            },
            isExpanded: false
        }

    },

    computed: {

        isSearching: function() {

            return this.model.search && this.isExpanded

        },

        selected: function() {

            if (!this.value.length) return []

            return this.$_.filter(this.options, function(option) {

                return this.$_.contains(this.value, option.value)

            }.bind(this))

        },

        finalOptions: function() {

            var options = this.$util.copy(this.options)

            if (this.value.length) {

                options = this.$_.filter(options, function(option) {

                    return !this.$_.contains(this.value, option.value)

                }.bind(this))

            }

            if (this.model.search) {

                options = this.$_.filter(options, function(option) {

                    return option.text.toLowerCase().indexOf(this.model.search.toLowerCase()) >= 0

                }.bind(this))

            }

            return options

        }

    },

    methods: {

        onOutsideClick: function() {

            this.isExpanded = false

        },

        onSelectionClick: function(value) {

            var values = this.$util.copy(this.value)

            values.splice(values.indexOf(value), 1)

            this.$emit('input', values)

            this.isExpanded = false

        },

        onOptionClick: function(value) {

            var values = this.$util.copy(this.value)

            values.push(value)

            this.$emit('input', values)

            this.model.search = ''
            this.isExpanded = false

        }

    }

}

</script>

<style scoped>

.multiselect-options {
    position: absolute;
    background-color: #fff;
    left: 0px;
    width: 100%;
    z-index: 2;
    border-radius: 4px;
    overflow: hidden;
    top: 41px;
}

.multiselect-option {
    padding: 10px 10px;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    font-weight: 400;
    color: #343434;
    border-bottom: 1px solid #eee;
}

.multiselect-option:last-child {
    border: 0px;
}

.multiselect-option:hover {
    background-color: #eee;
}

.multiselect-selections {
    margin-top: 10px;
}

.multiselect-selection {
    background-color: #3c6981;
    color: #fff;
    font-weight: 400;
    user-select: none;
    padding: 10px;
    margin-bottom: 1px;
    padding-right: 40px;
    cursor: pointer;
    min-height: 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    user-select: none;
}

.multiselect-selection:hover {
    background-color: #487994;
}

.multiselect-selection:first-child {
    border-radius: 4px 4px 0px 0px;
}

.multiselect-selection:last-child {
    border-bottom: 0px;
    border-radius: 0px 0px 4px 4px;
}

.multiselect-selection:first-child:last-child {
    border-radius: 4px;
}

.multiselect-selection-name {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
}

.multiselect-selection-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -12px;
    height: 24px;
    width: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    color: rgba(255, 255, 255, 1);
}

</style>
